module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.setModalTitle(_vm.type)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.type == 'random') ? _c('div', _vm._l((_vm.gameSvc.spotNumber), function(number) {
    return (_vm.isValid(number)) ? _c('button', {
      key: number,
      staticClass: "modal-btn",
      class: {
        is__active: _vm.activeRandom === number
      },
      on: {
        "click": function($event) {
          _vm.selectRandom(number)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.setRandomLabel(number)) + "\n                    ")]) : _vm._e()
  })) : (_vm.type == 'system' && _vm.bettingSvc.ticket.input.length) ? _c('div', _vm._l(((_vm.bettingSvc.ticket.input.length <= _vm.gameSvc.spotNumber && _vm.bettingSvc.ticket.input.length ? (_vm.bettingSvc.ticket.input.length - 1) : _vm.gameSvc.spotNumber)), function(number) {
    return (_vm.isValid(number, _vm.bettingSvc.ticket.input.length)) ? _c('button', {
      key: number,
      staticClass: "modal-btn",
      class: {
        is__active: _vm.activeSystem === number
      },
      on: {
        "click": function($event) {
          _vm.selectSystem(number)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.setSystemLabel(number, _vm.bettingSvc.ticket.input.length)) + "\n                    ")]) : _vm._e()
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn save-btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                    OK\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4151b208","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Modal.vue
// module id = 401
// module chunks = 0